<template>
  <div class="map__results">
    <div class="map__results__map" ref="mapContainer"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import L from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

// Fix for default marker icons in Leaflet with webpack
// eslint-disable-next-line no-underscore-dangle
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl
})

export default {
  data() {
    return {
      mapElement: null,
      markers: []
    }
  },

  mounted() {
    this.mapElement = L.map(this.$refs.mapContainer, {
      center: [this.map.center.lat, this.map.center.lng],
      zoom: this.map.zoom,
      zoomControl: true
    })

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapElement)

    this.addMarkers()

    this.$store.subscribe((mutation) => {
      if (!this.mapElement) return

      try {
        if (mutation.type === 'setCenter' || mutation.type === 'setZoom') {
          this.mapElement.setView([this.map.center.lat, this.map.center.lng], this.map.zoom)
        }

        if (mutation.type === 'setGarages') {
          this.addMarkers()
        }
      } catch (e) {
        // Ignore Leaflet internal errors during rapid updates
      }
    })
  },

  beforeDestroy() {
    if (this.mapElement) {
      this.mapElement.remove()
    }
  },

  methods: {
    addMarkers() {
      // Clear existing markers
      this.markers.forEach((marker) => {
        this.mapElement.removeLayer(marker)
      })
      this.markers = []

      // Add new markers
      this.garages.forEach((row) => {
        if (row.latLng) {
          const marker = L.marker([row.latLng.lat, row.latLng.lng]).addTo(this.mapElement)

          const content = this.createInfo(row.id)
          marker.bindPopup(content)

          marker.on('click', () => {
            this.$store.commit('setCenter', row.latLng)
            this.$store.commit('setZoom', 13)
          })

          this.markers.push(marker)
        }
      })
    },

    createInfo(id) {
      const me = this.garages.filter((row) => {
        return row.id === id
      })
      const content = `<div style="line-height: 1.5; text-align: left; padding: 5px;">
                                <h5 style="font-size: 18px; color: #ffa500;">${me[0].title}</h5>
                                <p><b>${me[0].address}</b></p>
                                <p>${me[0].phone}</p>
                                <p><a href="http://${me[0].website}" target="_blank" rel="noopener" style="color: #000; text-decoration: underline;">${me[0].website}</a></p>
                                <p>${me[0].hours}</p>
                                <div style="display: block; margin: 15px 0;">
                                    <a class="btn btn--primary btn--full" href="http://${me[0].website}" target="_blank" rel="noopener" style="width: 100%; display: block; text-align: center; background: #ffa500; color: black; font-weight: bold; font-size: 15px; padding: 10px 0; border-radius: 22px;">Időpontfoglalás</a>
                                </div>
                            </div>`

      return content
    }
  },

  filters: {
    formatDistance(n) {
      return Math.floor(n / 1000)
    }
  },

  computed: {
    ...mapState(['map', 'garages'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/tools.scss';
@import '../../assets/sass/layout/_wrapper.scss';

.map {
  &__results {
    &__map {
      width: 100%;
      height: 800px;
      display: block;
    }
  }
}

@media #{$mq--desktop} {
  .map {
    &__results {
      &__map {
        height: 500px;
      }
    }
  }
}
</style>
